import React from 'react';
import PropTypes from 'prop-types';
import RaisedButton from 'material-ui/RaisedButton';
import Checkbox from 'material-ui/Checkbox';
import './Facilities.scss';
import { PORT_FACILITIES } from 'constants/ports';

const FacilitiesApproval = ({
    changedValues = {},
    originalValues = {},
    onApprove,
    onReject,
}) => (
    <div className='facilities-block'>
        <div className='facilities-grid'>
            {PORT_FACILITIES.map(({ name, label }) => (
                (
                    <div 
                        key={name} 
                        className={`facility-item ${changedValues[name] !== originalValues[name] ? 'dirty-element' : ''}`}
                    >
                        <Checkbox
                            checked={changedValues[name]}
                            label={label}
                            disabled
                        />
                    </div>
                )
            ))}
        </div>
        <div className='form-actions'>
            <RaisedButton
                label='Approve'
                primary
                onClick={() => onApprove('facilities')}
                className='approve-button'
            />
            <RaisedButton
                label='Reject'
                secondary
                onClick={() => onReject('facilities')}
                className='reject-button'
            />
        </div>
    </div>
);

FacilitiesApproval.propTypes = {
    changedValues: PropTypes.object,
    originalValues: PropTypes.object,
    onApprove: PropTypes.func.isRequired,
    onReject: PropTypes.func.isRequired,
};

FacilitiesApproval.defaultProps = {
    changedValues: {},
    originalValues: {},
};

export default FacilitiesApproval;



// WEBPACK FOOTER //
// ./app/components/Regions/PortManagement/blocks/Facilities/FacilitiesApproval.jsx